var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('v-list-item',[_c('v-img',{attrs:{"src":_vm.src,"height":"50"}})],1),_c('v-list-item',[_c('v-file-input',{attrs:{"accept":"image/png","label":_vm.label},model:{value:(_vm.selectedFile),callback:function ($$v) {_vm.selectedFile=$$v},expression:"selectedFile"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }